// extracted by mini-css-extract-plugin
export default {"grid":"NeverPaySection_grid__itse9","card":"NeverPaySection_card__xObd4","mark":"NeverPaySection_mark__bpZR+"};